import React, { useState, useEffect, useContext } from 'react';
import { Collapse, Typography, Space, Button, Tooltip, Empty } from 'antd';
import { Status } from '../../Status/Status.component';
import { ShareAltOutlined, DeleteOutlined, CloseOutlined, SaveOutlined, WarningFilled, LoadingOutlined } from '@ant-design/icons';
import { AAP } from '../AAP/AAP.component';
import { VLAN } from '../VLAN/VLAN.component';
import { SNS } from '../SNS/SNS.component';
import { CAP } from '../CAP/CAP.component';
import { LTE } from '../LTE/LTE.component';
import { LTEFMS } from '../LTE/LTEFMS.component';
import { LTEEVC } from '../LTE/LTEEVC.component';
import { CSEVC } from '../CloudSwitches/CSEVC.component';
import { AwaitingCheckin } from '../AwaitingCheckin/AwaitingCheckin.component';
import { InDispenserSwitches } from '../InDispenserSwitches/InDispenserSwitches.component';
import { CloudSwitches } from '../CloudSwitches/CloudSwitches.component';
import { DeleteDeviceModal } from '../../../Modals/DeleteDeviceModal.component.';
import { ManageVLANModal } from '../VLAN/ManageVLANModal.component';
import { PendingChangesModal } from '../../../Modals/PendingChangesModal.component';
import { Restricted } from '../../../../UI/Restricted.component';
import { StationContext } from '../../../../../context/station-context';
import { NocItemContext } from '../../../../../context/noc-item-context';
import { saveStation } from '../../../../../services/StationService';
import './DevicesList.css';
import './DevicesListItem.css';
import { useNotificationApi } from '../../../../UI/NotificationProvider';
import { useMessage } from '../../../../UI/MessageProvider';

const { Text } = Typography;

export function getDeviceTitle(type) {
    let title;
    switch (type) {
        // Grouped
        case 'CAP-grouped':
            title = 'Cable Access Points (CAP)';
            break;
        case 'CS-grouped':
            title = 'Cloud Switches (CS)';
            break;
        case 'CSEVC-grouped':
            title = 'Cloud Switches EVC (CS-EVC)';
            break;
        case 'SUSW-grouped':
            title = 'In-Dispenser Switches (In-SU)';
            break;
        case 'postSW-grouped':
            title = 'Post Switches';
            break;


        case 'AAP': 
            title = 'AvaLAN Access Point (AAP)';
            break;
        case 'CAP': 
            title = 'Cable Access Point (CAP)';
            break;
        case 'SW': 
        case 'CS':
            title = 'Cloud Switch (CS)';
            break;
        case 'CS-EVC': 
            title = 'Cloud Switch EVC (CS-EVC)';
            break;
        case 'CSBASE': 
            title = 'Cloud Switch Base (CS-BASE)';
            break;
        case 'CSDFS': 
            title = 'Cloud Switch DFS (CS-DFS)';
            break;
        case 'CSEVC': 
            title = 'Cloud Switch EVC (CS-EVC)';
        break;
        case 'SNS': 
            title = 'Secure Network Service (SNS)';
            break;
        case 'SNSBASE': 
            title = 'Secure Network Service Base (SNS-BASE)';
            break;
        case 'SNSDFS': 
            title = 'Secure Network Service - Dover Fueling Solutions (SNS-DFS)';
            break;
        case 'SNSGVR':
            title = 'Secure Network Service - Gilbarco Veeder-Root (SNS-GVR)';
            break;
        case 'SUSW': 
        case 'SWSU':
        case 'SWSUCL':
        case 'SUSWCL':
            title = 'In-Dispenser Switch (In-SU)';
            break;
        case 'LTE':
            title = 'LTE'; 
            break;
        case 'LTEEVC':
            title = 'LTE-EVC'; 
            break;
        case 'LTEFMS':
            title = 'LTE-FMS';
            break;
        case 'VLAN': 
            title = 'VLAN Manager';
            break;
        default:
            title = 'Other Device'
            break;
        }
    return title;
}

export const GROUPED_DEVICES = ['CS', 'CSEVC', 'SUSW', 'postSW', 'other', 'VLAN', ];

export const DevicesList = ({...props}) => {

    const { 
        anthemProfiles,
        setPendingState, 
        pendingChangesModal, 
        setPendingChangesModal, 
        updateAllPendingChanges, 
        setUpdateAllPendingChanges,
        refresh,
        setProfileSettingsDevicesList,
    } = props;
    
    const notificationApi = useNotificationApi();
    const message = useMessage();

    const [stationState, stationDispatch] = useContext(StationContext);
    const [nocItemState, dispatchNocItem] = useContext(NocItemContext);

    const { station, pendingQueue, } = stationState;
    const { Devices, VLANTags, Macdevices, } = station;
    const [displayDeleteDevice, setDisplayDeleteDevice] = useState({display: false, item: ''});
    const [displayVLANModal, setDisplayVLANModal] = useState(false);
    const [listAAP, setListAAP] = useState([])
    const [listSUSW, setListSUSW] = useState([])
    const [listCAP, setListCAP] = useState([])
    const [listOtherDevices, setOtherDevices] = useState([])

    // CS
    const [listCS, setListCS] = useState([]);
    const [listCSEVC, setListCSEVC] = useState([]);
    
    // SNS
    const [listSNS, setListSNS] = useState([]);
    const [listSNSBASE, setListSNSBASE] = useState([]);
    const [listSNSDFS, setListSNSDFS] = useState([]);
    const [listSNSGVR, setListSNSGVR] = useState([]);

    // LTE 
    const [listLTE, setListLTE] = useState([]);
    const [listLTEFMS, setListLTEFMS] = useState([]);
    const [listLTEEVC, setListLTEEVC] = useState([]);

    const csType = ['CS', 'CSDFS', 'SW', 'CSBASE'];
    const subsUnitType = ['SUSW', 'SWSU', 'SWSUCL', 'SUSWCL'];
    const snsType = ['SNS', 'SNSGVR', 'SNSBASE', 'SNSDFS'];

    useEffect(() => {
        if (pendingQueue?.length > 0) {
            setPendingState(true);
        }
    }, [station])

    useEffect(() => {
        if (pendingQueue?.length > 0){
            setPendingState(true);
        } else {
            setPendingState(false);
        }
    }, [pendingQueue, setPendingState])

    useEffect(() => {
        if(updateAllPendingChanges){
            setPendingChangesModal(true)
        }
    }, [updateAllPendingChanges, setPendingChangesModal])

    useEffect(() => {
        const clearList = () => {
            setListAAP([])
            setListCAP([]);
            setListSUSW([]);
            setOtherDevices([]);
            setListCS([]);
            setListCSEVC([]);
            setListSNS([]);
            setListSNSBASE([]);
            setListSNSDFS([]);
            setListSNSGVR([]);
            setListLTE([]);
            setListLTEFMS([]);
            setListLTEEVC([]);
        }

        const matchDevice = () => {
            Devices?.forEach(device => {
                let type = device.deviceType;
                if (type === 'AAP' ){
                    setListAAP(listAAP => [...listAAP, device]);
                } else if (type === 'CAP'){
                    setListCAP(listCAP => [...listCAP, device]);
                } else if (csType.includes(type)){
                    setListCS(listCS => [...listCS, device]);
                } else if (type === 'CSEVC'){
                    setListCSEVC(listCSEVC => [...listCSEVC, device])
                } else if (type === 'SNS'){
                    setListSNS(listSNS => [...listSNS, device]);
                } else if (type === 'SNSBASE'){
                    setListSNSBASE(listSNSBASE => [...listSNSBASE, device]);
                } else if (type === 'SNSDFS'){
                    setListSNSDFS(listSNSDFS => [...listSNSDFS, device])
                } else if (type === 'SNSGVR'){
                    setListSNSGVR(listSNSGVR => [...listSNSGVR, device])
                } else if (subsUnitType.includes(type)){
                    setListSUSW(listSUSW => [...listSUSW, device]);
                } else if (type === 'LTE'){
                    setListLTE(listLTE => [...listLTE, device]);
                } else if (type === 'LTEFMS'){
                    setListLTEFMS(listLTEFMS => [...listLTEFMS, device]);
                } else if (type === 'LTEEVC'){
                    setListLTEEVC(listLTEEVC => [...listLTEEVC, device]);
                } else {
                    setOtherDevices(listOtherDevices => [...listOtherDevices, device]);
                }
            });
        }

        if(station){
            clearList();
            matchDevice();
        }

        if(refresh){
            clearList();
        }

    }, [station, nocItemState, dispatchNocItem, stationDispatch, Devices, Macdevices, VLANTags, refresh])

    useEffect(() => {
        setProfileSettingsDevicesList([...listSNSBASE, ...listCS.filter((device) => device.deviceType === 'CSBASE')]);
    }, [listSNSBASE, listCS])

    const renderNotification = (type, message, description) => {
        notificationApi[type]({
            message: message,
            description: description,
        });
    };

    const deleteDevice = (item) => {
        setDisplayDeleteDevice({display: true, title: getDeviceTitle(item.deviceType), item: item});
    }

    const isDevicePending = (id) => {
        const pendingIndex = pendingQueue?.findIndex(pendingItem => pendingItem.id === id);
        if(pendingIndex > -1){
            return true;
        } 
        return false;
    }

    const isPanelPending = (data) => {
        const ids = getDevicesIds(data);
        return pendingQueue?.some(pendingItem => ids.includes(pendingItem.id)); 
    }

    const cancelPendingChanges = (ids, formName) => {
        document.querySelectorAll(`[id=${formName}]`).forEach(form => form.reset());
        ids?.forEach((id) => {
            stationDispatch({
                type: 'REMOVE_PENDING_CHANGE', 
                payload: id,
            })
        })
    }

    const saveDevicePendingChanges = (ids) => {
        
        const devicesPendingChanges = [];
        const macPendingChanges = [];

        ids?.forEach(id => {
            const pendingIndex = pendingQueue?.findIndex(pendingItem => pendingItem.id === id);
            if (pendingIndex > -1){
                let item = pendingQueue[pendingIndex];
                if(item.deviceType !== undefined){
                    devicesPendingChanges.push(item)
                } else if(item.deviceType === undefined && item.vlanID){
                    macPendingChanges.push(item)
                }
            }
        })

        if(devicesPendingChanges.length > 0 ){
            saveStation({devices: devicesPendingChanges, dbID: station.id}).then(function (response) {
                if( response.result) {  
                    devicesPendingChanges.forEach((pendingItem) => {
                        stationDispatch({
                            type: 'UPDATE_DEVICE', 
                            payload: pendingItem.id
                        });
                        renderNotification('success', `${pendingItem.deviceType} #${pendingItem.serialNum}`, 'Changes have been saved successfully.')
                    })
                    return;
                }
                message.error("Something went wrong...", 5);
            });
        }

        //     macPendingChanges.forEach((pendingMac) => {
        //         stationDispatch({
        //             type: 'UPDATE_MAC_DEVICE', 
        //             payload: pendingMac.id
        //         });
        //         renderNotification('success', `MAC ${pendingMac.macAddr}`, 'Changes have been saved successfully.')
        //     })
        //     return;
        // } 
    }

    const saveStationAllPendingChanges = () => {
        saveStation({devices: pendingQueue, dbID: station.id}).then(function (response) {
            if( response.result) {  
                renderNotification('success', 'Success!', `Station ${station.name} has been updated.`);
                stationDispatch({
                    type: 'CLEAR_PENDING_QUEUE', 
                })
                setPendingState(false);
                return;
            }
            message.error("Something went wrong...", 5);
        });
    }

    const displayWarningIcon = (data) => {        
        const ids = getDevicesIds(data);
        return pendingQueue?.some(pendingItem => ids.includes(pendingItem.id)) ? <WarningFilled style={{color: 'var(--warning-color)', }}/> : null;
    }

    const getPanelClassName = (data) => {
        const ids = getDevicesIds(data);
        return `device__collapse__panel ${pendingQueue?.some(pendingItem => ids?.includes(pendingItem.id)) ? 'device__collapse__panel--pending' : ''}`
    };

    const getDevicesIds = (data) => {
        const idsArray = [];
        if(Array.isArray(data)){
            data.forEach((device) => {
                idsArray.push(device.id);
            })
        } else {
            idsArray.push(data?.id);
        }
        return idsArray;
    }

    const renderPanelHeader = (item) => {

        const header = (
            <div size="small">
                <Space align='baseline'>
                    {displayWarningIcon(item) }{getDeviceTitle(item.deviceType)} / <Text type="secondary">Serial Number: {item.serialNum}</Text>
                </Space>
            </div>
        );

        return header;
    }

    const renderGroupedPanelHeader = (data, deviceType) => {

        const header = (
            <div size="small">
                <Space align='baseline'>
                    {displayWarningIcon(data) }{getDeviceTitle(deviceType)}
                </Space>
            </div>
        );

        return header;
    }

    const renderPanelExtra = (data, deviceType, ...other) => {

        const ids = getDevicesIds(data);

        let formName; 

        const status = (!GROUPED_DEVICES.includes(deviceType)) ? <Status text="VPN Status" status={data.status}/>  : null
        const deleteDeviceButton = (isDevicePending(data?.id) ? 
            <Tooltip title="Device can't be deleted. Pending changes must be cleared.">
                <Button onClick={() => {deleteDevice(data)}} danger disabled={isDevicePending(data?.id)} type="primary" icon={<DeleteOutlined/>}/>
            </Tooltip> 
        : 
            <Button onClick={() => {deleteDevice(data)}} danger disabled={isDevicePending(data?.id)} type="primary" icon={<DeleteOutlined/>}/>
        )

        if(GROUPED_DEVICES.includes(deviceType)){
            formName = `${deviceType}-device-form`;
        } else {
            formName = `${data.deviceType}-${data.id}-device-form`;
        }

        const savePendingChangesEl = ( 
            pendingQueue?.length > 0 && pendingQueue?.some(pendingItem => ids.includes(pendingItem.id)) &&
                <Space>
                    {other}
                    <Button 
                        htmlType='submit'
                        form={formName}
                        onClick={() => GROUPED_DEVICES.includes(deviceType) ? saveDevicePendingChanges(ids) : null}
                        color='yellow'
                        variant='solid'
                        >
                        Save
                    </Button>
                    <Button 
                        onClick={() => cancelPendingChanges(ids, formName)} 
                        ghost 
                        type='primary'
                        >
                        Cancel
                    </Button>
                </Space>
        )

        const panelExtra =  (
            <Space>

                { status }

                <Restricted to='device.edit'>

                    { savePendingChangesEl }

                    { !pendingQueue?.some(pendingItem => ids.includes(pendingItem.id)) && other}
                
                </Restricted>
                
                <Restricted to='device.delete'>
                    { !GROUPED_DEVICES.includes(deviceType) && deleteDeviceButton}
                </Restricted>
            </Space>
            );
        return panelExtra;
    }

    const renderEditableCellValue = (value, record, dataIndex) => {
        if(isPanelPending(record)) {
            const pendingItem = pendingQueue?.find(pendingDevice => pendingDevice.id === record.id)
            return pendingItem[dataIndex];
        } else {
            return value;
        }
    }

    const renderAAP = () => {

        if (listAAP.length === 0) return [];
        
        return listAAP.map((item, index) => ({
            key: `AAP-${index}`,
            label: renderPanelHeader(item), 
            extra: renderPanelExtra(item, item.deviceType), 
            className: getPanelClassName(item), 
            children: (
                <AAP 
                    stationID={station?.id}
                    device={item} 
                    listAAP={listAAP} 
                    serialNum={item.serialNum} 
                    setSerialNumber={[]} 
                    signalStrength={item.SubscriberUnits} 
                    anthemProfiles={anthemProfiles} 
                    isPanelPending={isPanelPending} 
                    onSaveHandler={saveDevicePendingChanges}
                />
            )
        }));
    };

    const renderVLAN = () => {

        if(listSNS?.length === 0) return [];

        const extra = (
            <Restricted key={`VLAN-manager`} to='device.edit'>
                <Button key={`VLAN-manager`} className="btn__secondary--dark-gray" onClick={()=>{setDisplayVLANModal(true)}} icon={<ShareAltOutlined/>}>Manage VLANs</Button>
            </Restricted>
        )

        return {
            key: `VLAN`, 
            label: renderGroupedPanelHeader(Macdevices, 'VLAN'), 
            extra: renderPanelExtra(Macdevices, 'VLAN', extra), 
            className: getPanelClassName(Macdevices), 
            children: (
                <VLAN 
                    data={Macdevices} 
                    vlans={VLANTags} 
                    isPanelPending={isPanelPending} 
                    saveChanges={saveDevicePendingChanges} 
                    renderEditableCellValue={renderEditableCellValue} 
                />
            )
        };
    };
    
    const renderCloudSwitches = () => {
        
        if (listCS.length === 0) return [];

        return {
            key: 'CS', 
            label: renderGroupedPanelHeader(listCS, 'CS-grouped'), 
            extra: renderPanelExtra(listCS, 'CS'), 
            className: getPanelClassName(listCS), 
            children: (
                <CloudSwitches 
                    data={listCS} 
                    profileCombination={getProfileCombination()} 
                    isPanelPending={isPanelPending} 
                    renderEditableCellValue={renderEditableCellValue} 
                    saveChanges={saveDevicePendingChanges}
                />
            )
        }
    }

    const renderCSEVC = () => {

        if (listCSEVC.length === 0) return [];

        return {
            key: 'CSEVC', 
            label: renderGroupedPanelHeader(listCSEVC, 'CSEVC-grouped'), 
            extra: renderPanelExtra(listCSEVC, 'CSEVC'), 
            className: getPanelClassName(listCSEVC), 
            children: (
                <CSEVC 
                    data={listCSEVC} 
                    isPanelPending={isPanelPending} 
                    saveChanges={saveDevicePendingChanges} 
                    renderEditableCellValue={renderEditableCellValue} 
                />
            )
        }
    }
    
    const renderSNS = () => {

        if (listSNS.length === 0 ) return [];

        return listSNS.map((item, index) => ({
            key: `SNS-${index}`, 
            label: renderPanelHeader(item), 
            extra: renderPanelExtra(item, item.deviceType), 
            className: getPanelClassName(item),
            children: (
                <SNS 
                    serialNum={item.serialNum} 
                    data={item} 
                    isPanelPending={isPanelPending} 
                    onSaveHandler={saveDevicePendingChanges} 
                />
            )
        }));
    };

    const getPOSProfile = () => {

        const { posID } = stationState?.station?.profileSettings || {};
        
        if(posID){
            return nocItemState?.profiles?.data?.POS?.find(paymentProfile => paymentProfile.id === posID) || posID;  
        }

        return null;
    }

    const getProfileCombination = () => {

        const { POS, Dispenser } = nocItemState.profiles.data || {};
        const { posID, dispenserID } = stationState?.station?.profileSettings || {};

        const portCombination = {
            POS: POS?.find(paymentProfile => paymentProfile.id === posID) || posID, 
            Dispenser: Dispenser?.find(paymentProfile => paymentProfile.id === dispenserID) || dispenserID,
        };
        return portCombination; 
    }

    const renderSNSBASE = () => {

        if (listSNSBASE.length === 0) return [];

        return listSNSBASE.map((item, index) => ({
            key: `SNSBASE-${index}`, 
            label: renderPanelHeader(item),
            extra: renderPanelExtra(item, item.deviceType),
            className: getPanelClassName(item),
            children: (
                <SNS 
                    serialNum={item.serialNum} 
                    data={item} 
                    isPanelPending={isPanelPending} 
                    POS={getPOSProfile()} 
                    onSaveHandler={saveDevicePendingChanges} 
                />
            )
        }));
    }

    const renderSNSDFS = () => {

        if (listSNSDFS.length === 0) return [];

        return listSNSDFS.map((item, index) => ({
            key: `SNSDFS-${index}`, 
            label: renderPanelHeader(item), 
            extra: renderPanelExtra(item, item.deviceType), 
            className: getPanelClassName(item), 
            children: (
                <SNS 
                    serialNum={item.serialNum} 
                    data={item} 
                    isPanelPending={isPanelPending} 
                    onSaveHandler={saveDevicePendingChanges}
                />
            )   
        }));
    }

    const renderSNSGVR = () => {

        if (listSNSGVR.length === 0) return [];
        
        return listSNSGVR.map((item, index) => ({
            key: `SNSGVR-${index}`, 
            label: renderPanelHeader(item), 
            extra: renderPanelExtra(item, item.deviceType), 
            className: getPanelClassName(item), 
            children: (
                <SNS 
                    serialNum={item.serialNum} 
                    data={item} 
                    isPanelPending={isPanelPending} 
                    onSaveHandler={saveDevicePendingChanges}
                />
            )
        }));
    }

    const renderCAP = () => {

        if(listCAP.length === 0) return [];

        return listCAP.map((item, index) => ({
            key: `CAP-${index}`, 
            label: renderPanelHeader(item), 
            extra: renderPanelExtra(item, item.deviceType), 
            className: getPanelClassName(item), 
            children: (
                <CAP 
                    device={item} 
                    anthemProfiles={anthemProfiles} 
                    isPanelPending={isPanelPending} 
                    onSaveHandler={saveDevicePendingChanges}
                />
            )
        }));
    }
    
    const renderInDispenserSwitches = () => {

        const susws = listSUSW.filter((susw) => !susw.parityBits || susw.parityBits?.length < 8 );

        if (listSUSW.length === 0) return [];

        return {
            key: 'SUSW',
            label: renderGroupedPanelHeader(susws, 'SUSW-grouped'), 
            extra: renderPanelExtra(susws, 'SUSW'), 
            className: getPanelClassName(susws),
            children: (
                <InDispenserSwitches 
                    data={susws} 
                    isPanelPending={isPanelPending} 
                    renderEditableCellValue={renderEditableCellValue} 
                    saveChanges={saveDevicePendingChanges}
                />
            )
        }
    }

    const renderPostSwitches = () =>{
        
        const postSwitches = listSUSW.filter((susw) => susw.parityBits?.length >= 8 );

        if (postSwitches.length === 0) return [];

        return {
            key: 'postSwitches', 
            label: renderGroupedPanelHeader(postSwitches, 'postSW-grouped'), 
            extra: renderPanelExtra(postSwitches, 'postSW'), 
            className: getPanelClassName(postSwitches),
            children: ( 
                <InDispenserSwitches 
                    data={postSwitches} 
                    isPanelPending={isPanelPending} 
                    renderEditableCellValue={renderEditableCellValue} 
                    saveChanges={saveDevicePendingChanges}
                />
            )
        }
    }
    
    const renderLTE = () => {

        if (listLTE.length === 0) return [];

        return listLTE.map((item, index) => ({
            label: renderPanelHeader(item), 
            key: `LTE-${index}`, 
            extra: renderPanelExtra(item, item.deviceType), 
            className: getPanelClassName(item), 
            children: (
                <LTE 
                    device={item} 
                    serialNum={item.serialNum} 
                    setSerialNumber={[]} 
                    isPanelPending={isPanelPending} 
                    onSaveHandler={saveDevicePendingChanges}
                />
            )
        }));
    }

    const renderLTEFMS = () => {

        if (listLTEFMS.length === 0) return [];

        return listLTEFMS.map((item, index) => ({
            label: renderPanelHeader(item), 
            key: `LTEFMS-${index}`,
            extra: renderPanelExtra(item, item.deviceType), 
            className: getPanelClassName(item), 
            children: (
                <LTEFMS 
                    device={item} 
                    serialNum={item.serialNum} 
                    setSerialNumber={[]} 
                    isPanelPending={isPanelPending} 
                    onSaveHandler={saveDevicePendingChanges}
                />
            )
        }));
    }

    const renderLTEEVC = () => {

        if (listLTEEVC.length === 0) return [];

        return listLTEEVC.map((item, index) => ({
            label: renderPanelHeader(item), 
            key: `LTEEVC-${index}`, 
            extra: renderPanelExtra(item, item.deviceType), 
            className: getPanelClassName(item), 
            children: (
                <LTEEVC 
                    device={item} 
                    serialNum={item.serialNum} 
                    setSerialNumber={[]} 
                    isPanelPending={isPanelPending} 
                    onSaveHandler={saveDevicePendingChanges}
                />
            )
        }))
    }

    const renderOtherDevices = () => {
    
        if(listOtherDevices.length === 0) return [];

        return {
            key: 'other-devices', 
            label: renderGroupedPanelHeader(listOtherDevices, 'other'), 
            extra: renderPanelExtra(listOtherDevices, 'other'), 
            className: getPanelClassName(listOtherDevices),
            children: (
                <AwaitingCheckin 
                    data={listOtherDevices} 
                    isPanelPending={isPanelPending} 
                    renderEditableCellValue={renderEditableCellValue} 
                    saveChanges={saveDevicePendingChanges} 
                />
            )
        }
    };
    
    const renderDevices = () => {
    
        let list = [
            renderSNS(),
            renderSNSBASE(),
            renderSNSDFS(),
            renderSNSGVR(),
            renderAAP(), 
            renderVLAN(),
            renderInDispenserSwitches(),
            renderPostSwitches(),
            renderCAP(), 
            renderCloudSwitches(),
            renderCSEVC(),
            renderLTE(),
            renderLTEEVC(),
            renderLTEFMS(),
            renderOtherDevices(),
        ]
        return list.flat();
    }

    return(
        <>
            { Devices?.length > 0 ? 
                <Collapse 
                    ghost 
                    collapsible="header"
                    className="devices__collapse"
                    key={`station-${station.id}-devices-list`}
                    items={renderDevices()}
                /> 
                : 
                <Empty
                    description={<Text type='secondary'>No devices to display</Text>}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            }
            
            { displayDeleteDevice.display ? 
                    <DeleteDeviceModal title={displayDeleteDevice.title} item={displayDeleteDevice.item} visible={displayDeleteDevice.display} setVisible={setDisplayDeleteDevice}></DeleteDeviceModal>
                : null 
            }

            {pendingChangesModal && !updateAllPendingChanges ?
                <PendingChangesModal station={station.name} setPendingState={setPendingState} displayModal={pendingChangesModal} setDisplayModal={setPendingChangesModal} />
                : null 
            }

            {pendingChangesModal && updateAllPendingChanges ?
                <PendingChangesModal updateAll={updateAllPendingChanges} setUpdateAll={setUpdateAllPendingChanges} saveAllPendingChanges={saveStationAllPendingChanges} station={station.name} setPendingState={setPendingState} displayModal={pendingChangesModal} setDisplayModal={setPendingChangesModal} />
                : null 
            }

            { displayVLANModal && 
                <ManageVLANModal dataSource={VLANTags} displayModal={displayVLANModal} setDisplayModal={setDisplayVLANModal}/> 
            }
        </>
    );
};